// Updated with RBAC integration
// third-party
// Updated with RBAC integration
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// Updated with RBAC integration

// Updated with RBAC integration
// project imports
// Updated with RBAC integration
import axios2 from 'utils/axios2';
// Updated with RBAC integration
import {
    // Updated with RBAC integration
    hasPermission,
    // Updated with RBAC integration
    getUserContext,
    // Updated with RBAC integration
    createAuditEntry
    // Updated with RBAC integration
} from '../../utils/rbac';
// Updated with RBAC integration
// Updated with RBAC integration

// Updated with RBAC integration
// ----------------------------------------------------------------------
// Updated with RBAC integration

// Updated with RBAC integration
// Async thunks
// Updated with RBAC integration
export const fetchJupyterServers = createAsyncThunk(
    // Updated with RBAC integration
    'datahubJupyter/fetchServers',
    // Updated with RBAC integration
    async (projectId, { rejectWithValue }) => {
        // Updated with RBAC integration
        try {
            // Updated with RBAC integration
            const { user_token, user_permissions, user_groups, user_id } = getUserContext();
            // Updated with RBAC integration

            // Updated with RBAC integration
            // Check servers view permission
            // Updated with RBAC integration
            if (!hasPermission(user_permissions, 'servers', 'view')) {
                // Updated with RBAC integration
                throw new Error('Insufficient permissions: Cannot view Jupyter servers');
                // Updated with RBAC integration
            }
            // Updated with RBAC integration

            // Updated with RBAC integration
            const response = await axios2.get('/datahub/jupyter/servers', {
                // Updated with RBAC integration
                params: {
                    // Updated with RBAC integration
                    projectId,
                    // Updated with RBAC integration
                    user_token,
                    // Updated with RBAC integration
                    permissions: user_permissions,
                    // Updated with RBAC integration
                    groups: user_groups
                    // Updated with RBAC integration
                }
                // Updated with RBAC integration
            });
            // Updated with RBAC integration

            // Updated with RBAC integration
            // Create audit entry
            // Updated with RBAC integration
            const auditEntry = createAuditEntry(
                // Updated with RBAC integration
                user_id,
                // Updated with RBAC integration
                'fetch_jupyter_servers',
                // Updated with RBAC integration
                'jupyter',
                // Updated with RBAC integration
                projectId,
                // Updated with RBAC integration
                true
                // Updated with RBAC integration
            );
            // Updated with RBAC integration

            // Updated with RBAC integration
            return response.data;
            // Updated with RBAC integration
        } catch (error) {
            // Updated with RBAC integration
            // Create audit entry for failed operation
            // Updated with RBAC integration
            const { user_id } = getUserContext();
            // Updated with RBAC integration
            const auditEntry = createAuditEntry(
                // Updated with RBAC integration
                user_id,
                'fetch_jupyter_servers',
                'jupyter',
                projectId,
                false,
                error.message
            );

            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const startJupyterServer = createAsyncThunk(
    'datahubJupyter/startServer',
    async ({ projectId, serverName, config = {} }, { rejectWithValue }) => {
        try {
            const { user_token, user_permissions, user_groups, user_id } = getUserContext();

            // Check server start permission
            if (!hasPermission(user_permissions, 'servers', 'start')) {
                throw new Error('Insufficient permissions: Cannot start Jupyter server');
            }

            const response = await axios2.post('/datahub/jupyter/servers/start', {
                projectId,
                serverName,
                config,
                user_token,
                permissions: user_permissions,
                groups: user_groups,
                audit: {
                    action: 'start_jupyter_server',
                    resource_type: 'servers',
                    details: {
                        server_name: serverName,
                        config: config
                    }
                }
            });

            // Create audit entry
            const auditEntry = createAuditEntry(user_id, 'start_jupyter_server', 'servers', response.data.id, true);

            return response.data;
        } catch (error) {
            // Create audit entry for failed operation
            const { user_id } = getUserContext();
            const auditEntry = createAuditEntry(user_id, 'start_jupyter_server', 'servers', 'new', false, error.message);

            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const stopJupyterServer = createAsyncThunk('datahubJupyter/stopServer', async ({ projectId, serverId }, { rejectWithValue }) => {
    try {
        const { user_token, user_permissions, user_groups, user_id } = getUserContext();

        // Check server stop permission
        if (!hasPermission(user_permissions, 'servers', 'stop')) {
            throw new Error('Insufficient permissions: Cannot stop Jupyter server');
        }

        await axios2.post(`/datahub/jupyter/servers/${serverId}/stop`, {
            projectId,
            user_token,
            permissions: user_permissions,
            groups: user_groups,
            audit: {
                action: 'stop_jupyter_server',
                resource_type: 'servers',
                details: {
                    server_id: serverId
                }
            }
        });

        // Create audit entry
        const auditEntry = createAuditEntry(user_id, 'stop_jupyter_server', 'servers', serverId, true);

        return serverId;
    } catch (error) {
        // Create audit entry for failed operation
        const { user_id } = getUserContext();
        const auditEntry = createAuditEntry(user_id, 'stop_jupyter_server', 'servers', serverId, false, error.message);

        return rejectWithValue(error.response?.data || error.message);
    }
});

export const fetchNotebooks = createAsyncThunk(
    'datahubJupyter/fetchNotebooks',
    async ({ projectId, serverId, path = '/' }, { rejectWithValue }) => {
        try {
            const { user_token, user_permissions, user_groups, user_id } = getUserContext();

            // Check notebooks view permission
            if (!hasPermission(user_permissions, 'notebooks', 'view')) {
                throw new Error('Insufficient permissions: Cannot view notebooks');
            }

            const response = await axios2.get('/datahub/jupyter/notebooks', {
                params: {
                    projectId,
                    serverId,
                    path,
                    user_token,
                    permissions: user_permissions,
                    groups: user_groups
                }
            });

            // Create audit entry
            const auditEntry = createAuditEntry(user_id, 'fetch_notebooks', 'notebooks', serverId, true);

            return response.data;
        } catch (error) {
            // Create audit entry for failed operation
            const { user_id } = getUserContext();
            const auditEntry = createAuditEntry(user_id, 'fetch_notebooks', 'notebooks', serverId, false, error.message);

            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const createNotebook = createAsyncThunk(
    'datahubJupyter/createNotebook',
    async ({ projectId, serverId, notebookName, path = '/' }, { rejectWithValue }) => {
        try {
            const { user_token, user_permissions, user_groups, user_id } = getUserContext();

            // Check notebook create permission
            if (!hasPermission(user_permissions, 'notebooks', 'create')) {
                throw new Error('Insufficient permissions: Cannot create notebooks');
            }

            const response = await axios2.post('/datahub/jupyter/notebooks/create', {
                projectId,
                serverId,
                notebookName,
                path,
                user_token,
                permissions: user_permissions,
                groups: user_groups,
                audit: {
                    action: 'create_notebook',
                    resource_type: 'notebooks',
                    details: {
                        notebook_name: notebookName,
                        path: path,
                        server_id: serverId
                    }
                }
            });

            // Create audit entry
            const auditEntry = createAuditEntry(user_id, 'create_notebook', 'notebooks', response.data.id, true);

            return response.data;
        } catch (error) {
            // Create audit entry for failed operation
            const { user_id } = getUserContext();
            const auditEntry = createAuditEntry(user_id, 'create_notebook', 'notebooks', 'new', false, error.message);

            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const requestGPU = createAsyncThunk(
    'datahubJupyter/requestGPU',
    async ({ projectId, serverId, gpuCount = 1 }, { rejectWithValue }) => {
        try {
            const { user_token, user_permissions, user_groups, user_id } = getUserContext();

            // Check GPU request permission
            if (!hasPermission(user_permissions, 'compute', 'request_gpu')) {
                throw new Error('Insufficient permissions: Cannot request GPU resources');
            }

            const response = await axios2.post('/datahub/jupyter/compute/request-gpu', {
                projectId,
                serverId,
                gpuCount,
                user_token,
                permissions: user_permissions,
                groups: user_groups,
                audit: {
                    action: 'request_gpu',
                    resource_type: 'compute',
                    details: {
                        gpu_count: gpuCount,
                        server_id: serverId
                    }
                }
            });

            // Create audit entry
            const auditEntry = createAuditEntry(user_id, 'request_gpu', 'compute', serverId, true);

            return response.data;
        } catch (error) {
            // Create audit entry for failed operation
            const { user_id } = getUserContext();
            const auditEntry = createAuditEntry(user_id, 'request_gpu', 'compute', serverId, false, error.message);

            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// ----------------------------------------------------------------------

const initialState = {
    servers: [],
    currentServer: null,
    notebooks: [],
    loading: false,
    error: null,
    stats: {
        activeServers: 0,
        totalNotebooks: 0,
        activeUsers: 0
    }
};

// ----------------------------------------------------------------------

const slice = createSlice({
    name: 'datahubJupyter',
    initialState,
    reducers: {
        setCurrentServer(state, action) {
            state.currentServer = action.payload;
        },
        clearError(state) {
            state.error = null;
        },
        clearNotebooks(state) {
            state.notebooks = [];
        }
    },
    extraReducers: (builder) => {
        builder
            // fetchJupyterServers
            .addCase(fetchJupyterServers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchJupyterServers.fulfilled, (state, action) => {
                state.loading = false;
                state.servers = action.payload.servers || [];
                state.stats = action.payload.stats || state.stats;
            })
            .addCase(fetchJupyterServers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // startJupyterServer
            .addCase(startJupyterServer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(startJupyterServer.fulfilled, (state, action) => {
                state.loading = false;
                state.servers.push(action.payload);
            })
            .addCase(startJupyterServer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // stopJupyterServer
            .addCase(stopJupyterServer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(stopJupyterServer.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.servers.findIndex((server) => server.id === action.payload);
                if (index !== -1) {
                    state.servers[index].status = 'stopped';
                }
            })
            .addCase(stopJupyterServer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // fetchNotebooks
            .addCase(fetchNotebooks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNotebooks.fulfilled, (state, action) => {
                state.loading = false;
                state.notebooks = action.payload.notebooks || [];
            })
            .addCase(fetchNotebooks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // createNotebook
            .addCase(createNotebook.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createNotebook.fulfilled, (state, action) => {
                state.loading = false;
                state.notebooks.push(action.payload);
            })
            .addCase(createNotebook.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // requestGPU
            .addCase(requestGPU.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(requestGPU.fulfilled, (state, action) => {
                state.loading = false;
                // Update server with GPU allocation
                const index = state.servers.findIndex((server) => server.id === action.payload.serverId);
                if (index !== -1) {
                    state.servers[index].gpuAllocation = action.payload.gpuAllocation;
                }
            })
            .addCase(requestGPU.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

// ----------------------------------------------------------------------

// Reducer
export default slice.reducer;

// Actions
export const { setCurrentServer, clearError, clearNotebooks } = slice.actions;
